import type { ReactNode } from 'react';
import {
  StyledEngineProvider,
  THEME_ID,
  ThemeProvider,
} from '@mui/material/styles';

import marketviewMuiTheme from 'theme';

interface MuiProvidersProps {
  children: ReactNode;
}

const MuiProviders = ({ children }: MuiProvidersProps) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={{ [THEME_ID]: marketviewMuiTheme }}>
      {children}
    </ThemeProvider>
  </StyledEngineProvider>
);

export default MuiProviders;
